// extracted by mini-css-extract-plugin
export var active = "_ga-7";
export var blink = "_ga-8";
export var dropDownSelector = "_ga-4";
export var dropDownWrapper = "_ga-3";
export var fakeCursor = "_ga-6";
export var fontSizeButton = "_ga-9";
export var formQuillEditor = "_ga-0";
export var pressed = "_ga-a";
export var qlBlank = "_ga-1";
export var textFormattingToolbar = "_ga-2";
export var textToolbarOption = "_ga-5";